import React, { FC } from "react";

import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { REGISTER_ARTIST_URL } from "../../links";
import Button from "@material-ui/core/Button";
import dashboardPreview from "../../images/dashboard2.png";

interface IArtistSectionProps {}

const ArtistSection: FC<IArtistSectionProps> = (props) => {
	return (
		<Box 
			width="100%" 
			style={{
				background: "linear-gradient(rgb(29, 194, 186), rgb(2, 22, 43) 89%)",
				minHeight: "100vh",
				padding: "100px 0",
			}}
		>
			<Container>
				<Grid
					style={{ height: "100%" }}
					justify="space-between"
					alignItems="center"
					container={true}
				>
					<Grid item={true} xs={12} sm={12} md={12} lg={5} xl={5}>
						<Box display="flex" alignItems="flex-end" mb={4}>
							<Typography
								style={{
									letterSpacing: -24,
									marginRight: 26,
									fontWeight: 500,
									fontSize: 180,
									color: "white",
								}}
							>
								//
							</Typography>
							<Typography
								style={{
									letterSpacing: -5,
									fontWeight: 500,
									fontSize: 110,
									lineHeight: "85px",
									color: "white",
								}}
								gutterBottom
								variant="h1"
							>
								for the artist
								<span style={{ color: "#B04ED5", fontFamily: "cursive" }}>
									.
								</span>
							</Typography>
						</Box>

						<Typography
							style={{
								marginBottom: 20,
								color: "white",
							}}
							variant="body1"
						>
							What makes StarFarm a game changer for the music industry? Unlike
							traditional music streaming platforms, StarFarm is backed by
							blockchain technology. What's blockchain technology you might ask
							and why does it matter? Well, it matters because the music
							industry has historically not been very good at what it comes to
							paying them. Blockchain technology completely disrupts
							the current system and simplifies it by being completely
							transparent and immutable. With StarFarm, artists get paid for
							each and every play, get to pick the price per play and get paid
							instantly. It's that simple.
						</Typography>

						<Typography style={{ color: "white", marginBottom: 40 }}>
							StarFarm. We Grow Stars.
						</Typography>

						<Box display="flex" justifyContent="flex-start">
							<Button
								component="a"
								href={REGISTER_ARTIST_URL}
								variant="contained"
								color="secondary"
								style={{
									borderRadius: 25,
									padding: "14px 56px",
									textTransform: "uppercase",
									fontSize: 16,
									fontWeight: 500,
									minWidth: 200,
								}}
							>
								start earning
							</Button>
						</Box>
					</Grid>

					<Grid item={true} xs={12} sm={12} md={12} lg={6} xl={6}>
						<img
							src={dashboardPreview}
							style={{ maxHeight: 800, maxWidth: "100%" }}
							height="auto"
							width="auto"
							alt=""
						/>
					</Grid>
				</Grid>
			</Container>
		</Box>
	);
};

export default ArtistSection;

